import { IAddressSearchResolveResult } from '@cbgms/api/modules/miscellaneous/address/search'

export const EmptyAddress = (): IAddressSearchResolveResult => {
  return {
    Street: '',
    HouseNumber: '',
    City: '',
    Country: '',
    State: '',
    ZipCode: '',
    FormattedAddress: '',
    AdditionalAddressLines: ''
  }
}
